import React, { useEffect, useRef, useState } from 'react';
import { normalizeTwoWords } from '../../../shared/utils/stringUtilities';
import CardNews from '../../atoms/card-news/cardNews';
import { Fade, Typography } from '@mui/material';
import './galleryCards.scss';

export interface IGalleryCardsProps {
    id?: string;
    title: string;
    subtitle: any;
    categoryName: string;
    cards: [
        {
            image: string;
            subtitle: string;
            title: string;
            redirect: string;
        },
    ];
}

const GalleryCards = ({
    id = '',
    title,
    subtitle,
    cards,
    categoryName,
}: IGalleryCardsProps) => {
    const [isVisible, setIsVisible] = useState(false);
    const GalleryRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setIsVisible(entries[0].isIntersecting);
            }
        });
        if (GalleryRef.current) {
            observer.observe(GalleryRef.current);
        }
        return () => observer.disconnect();
    }, []);

    const getCard = (_card: any, _i: number) => {
        return (
            <CardNews
                key={`card${_i}`}
                imgSrc={_card.image}
                imgAlt={_card.subtitle}
                title={_card.title}
                link={_card.redirect}
                label={_card.subtitle}
                gtmMark={`gtm${normalizeTwoWords(
                    categoryName,
                )}${normalizeTwoWords(title)}${normalizeTwoWords(
                    _card.subtitle,
                )}Tarjeta${_i}`}
                modeGallery={true}
            />
        );
    };

    return (
        <Fade in={isVisible} timeout={1000}>
            <section ref={GalleryRef} className="o-gallery-cards" id={id}>
                <>
                    {subtitle && (
                        <Typography variant="body1" className="a-home__desc">
                            {subtitle}
                        </Typography>
                    )}
                    {title && (
                        <Typography component="h2" className="a-home__h2">
                            {title}
                        </Typography>
                    )}
                </>
                <div className="o-gallery-cards__cont">
                    {cards.map((card, i) => getCard(card, i))}
                </div>
            </section>
        </Fade>
    );
};

export default GalleryCards;
